import { useMutation } from "react-query";
import { rejectProduct } from "components/photography/lib/photoData";

// TODO: this needs to be moved to a shared folder
export const useRejectToSupplier = () => {
    return useMutation(({ wipKey, payload }) => rejectProduct(wipKey, payload));
};
